<template>
  <div id="checklistThree"></div>
</template>

<script>
export default {
  name: "ChecklistThree",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        title: "Content Launch Checklist",
        items: [
          { text: "Write compelling headline", checked: true },
          { text: "Add visuals and graphics", checked: true },
          { text: "Proofread for errors", checked: false },
          { text: "Schedule for optimal time", checked: false },
        ],
        chip: "Checklist",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler() {
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    render() {
      const el = document.getElementById("checklistThree");
      if (!el) return;
      el.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const titleSize = exporting ? 50 : 50 * this.scale;
      const itemSize = exporting ? 30 : 30 * this.scale;
      const checkSize = exporting ? 36 : 36 * this.scale;
      const logoHeight = exporting ? 45 : 45 * this.scale;
      const chipSize = exporting ? 18 : 18 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.dark || "";
      const primaryColor =
        this.workspace?.branding?.color?.primary || "#22c55e";

      const items = this.data.items || [];
      const itemsHtml = items
        .map(
          (item) => `
        <div style="display: flex; align-items: flex-start; margin-bottom: 24px;">
          <div style="
            font-size: ${checkSize}px;
            margin-right: 16px;
            flex-shrink: 0;
            line-height: 1;
          ">${item.checked ? "✅" : "⬜"}</div>
          <div style="
            font-size: ${itemSize}px;
            font-weight: ${item.checked ? "600" : "400"};
            color: ${item.checked ? "#1a1a1a" : "#999999"};
            line-height: 1.4;
            font-family: 'Inter', 'Helvetica Neue', sans-serif;
            ${item.checked ? "" : "text-decoration: line-through;"}
          ">${item.text}</div>
        </div>
      `,
        )
        .join("");

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background-color: #fafafa;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
            position: relative;
            overflow: hidden;
          "
        >
          <!-- Header with logo -->
          <div style="padding: 8%; position: relative; z-index: 1;">
            <img src="${logoSrc}" height="${logoHeight}px" alt="" />
          </div>

          <!-- Checklist content -->
          <div style="padding: 0 8% 8% 8%; position: relative; z-index: 1;">
            <div style="margin-bottom: 40px;">
              <p style="
                font-size: ${titleSize}px;
                font-family: 'Playfair Display', 'Georgia', serif;
                font-weight: 700;
                color: #1a1a1a;
                line-height: 1.2;
                margin: 0;
                display: inline-block;
                position: relative;
              ">
                ${this.data.title}
                <span style="
                  position: absolute;
                  bottom: -8px;
                  left: 0;
                  width: 60%;
                  height: 4px;
                  background: ${primaryColor};
                "></span>
              </p>
            </div>

            <div>
              ${itemsHtml}
            </div>

            <!-- Chip -->
            <div style="display: flex; margin-top: 24px;">
              <span
                style="
                  display: inline-block;
                  background: #1a1a1a;
                  color: #ffffff;
                  font-size: ${chipSize}px;
                  font-weight: 600;
                  border-radius: 4px;
                  padding: 12px 20px;
                  letter-spacing: 0.08em;
                  text-transform: uppercase;
                  font-family: 'Inter', 'Helvetica Neue', sans-serif;
                "
              >
                ${this.data.chip}
              </span>
            </div>
          </div>
        </div>
      </div>
      `;

      return html;
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;900&display=swap");
</style>
